module.exports = __webpack_public_path__ + "img/SFAC_logo.svg";